<template>
  <div class="play-tab-list" :style="{'border-radius': type=='pc'?'32px':'16px'}">
    <div class="tab-date" :style="{'height': type=='pc'?'56px':'43px'}">
      <div
        :class="[currentActiveDate == item.id ? 'active' : '', 'date-item']"
        :style="{'font-size': type=='pc'?'16px':'14px'}"
        v-for="item in dateList"
        :key="item.id"
        @click="changeActiveDate(item)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="tab-type" :style="{'height': type=='pc'?'84px':'64px'}">
      <div class="type-list" :style="{'height': type=='pc'?'40px':'32px','width': type=='pc'?'214px':'164px'}">
        <div
          :class="[currentActiveType == item.title ? 'active' : '', 'type-item']"
          :style="{'font-size': type=='pc'?'14px':'12px'}"
          v-for="item in typeList"
          :key="item.id"
          @click="changeActiveType(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="list-box" :style="{'height': type=='pc'?'calc(100% - 140px)':'calc(100% - 107px)'}">
      <div class="list-left" v-if="summitList.length>0">
        <div class="list-item"
          v-for="item in summitList"
          :key="item.id"
          :style="{'margin-bottom': type=='pc'?'20px':'12px'}"
        >
          <div
            :class="[currentActiveSummit.id==item.id?'item-title-active':'item-title', 'van-ellipsis']"
            @click="changeActiveSummit(item)"
            :style="{'font-size': type=='pc'?'14px':'12px'}"
          >
          <a-tooltip>
            <template #title>{{ item.title }}</template>
            <span class="title-text">{{ item.title }}</span>
          </a-tooltip>
          </div>
        </div>
      </div>
      <div class="list-right" v-if="themeList.length>0">
        <div class="list-item"
          v-for="item in themeList"
          :key="item.id"
          @click="toDetail()"
          :style="{'margin-bottom': type=='pc'?'20px':'12px'}"
        >
          <div class="item-title van-ellipsis" :style="{'font-size': type=='pc'?'14px':'12px'}">
            <a-tooltip>
              <template #title>{{ item.title }}</template>
               <span class="title-text">{{ item.title }}</span>
            </a-tooltip>
            </div>
            <!-- <div class="item-time">{{ extractHourAndMinute(item.start_time) }}-{{
              extractHourAndMinute(item.end_time)
            }}</div> -->
            <div class="item-time"
              v-if="item.speakers[0]?.name"
              :style="{'font-size': type=='pc'?'14px':'12px','margin-top': type=='pc'?'4px':'2px'}"
            >{{item.speakers[0]?.name}}</div>
        </div>
      </div>
      <div class="list-none" v-if="summitList.length==0">暂无数据</div>
    </div>
  </div>
</template>

<script setup>
import { getSchedule,getScheduleDetail,getScheduleVidoe } from '@/api/2024'
import { ref, onBeforeMount } from 'vue'

const props = defineProps({
    type: {
        type: String,
        default: 'pc'
    }
})

const emit = defineEmits(["playVideo"])
onBeforeMount(async () => {
  await fetch('2024-07-31', '主题峰会')
})

let currentActiveDate = ref('2024-07-31')
let dateList = ref([
  { id: '2024-07-31', title: '7月31号' },
  { id: '2024-08-01', title: '8月1号' },
  { id: '2024-08-02', title: '8月2号' }
])

let currentActiveType = ref('主题峰会')
let typeList = ref([
  { id: 0, title: '主题峰会' },
  { id: 1, title: '主题论坛' }
])

const currentActiveSummit = ref({}) //当前选中大会项
let toDetailUrl = ref('') //当前选中大会项详情页
let summitList = ref([]) //大会列表（只显示有视频的）
let themeList = ref([]) //大会详细流程

const fetch = (date, type) => {
  return getSchedule(date, type)
  .then((res) => {
    if(res.data.data.list==0){
      summitList.value = []
    }else{
      summitList.value = res.data.data.list[date].filter((item) => item.video_url)
    }
      if(summitList.value.length > 0){
        currentActiveSummit.value = summitList.value[0]
        return getDetailList(currentActiveSummit.value)
      }else{
        return getDetailList()
      }
    })
    .catch(() => {})
}

const getDetailList = (item={}) =>{
  if(item.video_id){
    getScheduleDetail(item.id)
      .then((res) => {
        toDetailUrl.value = res.data.data.video_url
        if(res.data.data.agendas){
          themeList.value = res.data.data.agendas
        }else{
          themeList.value = []
        }
        getScheduleVidoe(item.video_id).then((result)=>{
          currentActiveSummit.value.hlsUrl = result.data.data.videoinfo.hlsurl
          currentActiveSummit.value.imgurl = result.data.data.videoinfo.imgurl
          emit('playVideo',currentActiveSummit.value)
        })
      })
      .catch(() => {})
  }else{
    emit('playVideo',{
      hlsUrl: '',
      imgurl: '',
      title: '暂无回放'
    })
    themeList.value = []
  }
}

function extractHourAndMinute(timeString) {
  const match = timeString.match(/^(\d{2}:\d{2})/)
  return match ? match[1] : ''
}

const changeActiveDate = async (item) => {
  currentActiveDate.value = item.id
  await fetch(currentActiveDate.value, currentActiveType.value)
}
const changeActiveType = async (item) => {
  currentActiveType.value = item.title
  await fetch(currentActiveDate.value, currentActiveType.value)
}
const changeActiveSummit = (item) => {
  currentActiveSummit.value = item
  return getDetailList(currentActiveSummit.value)
}
const toDetail = () =>{
  // const baseUrl = window.location.origin
  // window.open(`${baseUrl}/new/2024/agenda/detail.html?id=${currentActiveSummit.value.id}`, '_blank')
  window.open(toDetailUrl.value)
}

defineExpose({
  currentActiveSummit 
})
</script>

<style lang="scss" scoped>
.play-tab-list {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 0 24px;
  .tab-date {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #e8eaed;
    .date-item {
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #525966;
      &:hover {
        color: #242933;
      }
      &.active {
        color: #242933;
        font-weight: 500;
        border-bottom: 2px solid #242933;
      }
    }
  }
  .tab-type {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .type-list {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 214px;
      background: #f2f3f5;
      border-radius: 8px;
      padding: 2px;
      .type-item {
        height: 100%;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #525966;
        font-size: 14px;
        &:hover {
          color: #242933;
        }
        &.active {
          color: #242933;
          font-weight: 600;
          background: #ffffff;
          border-radius: 8px;
        }
      }
    }
  }
  .list-box {
    width: 100%;
    display: flex;
    padding-bottom: 20px;
    height: calc(100% - 140px);
    
    .list-left {
      width: 50%;
      padding-right: 24px;
      border-right: 1px solid #e8eaed;
      height: 100%;
      overflow: auto;
      .list-item {
        display: flex;
        cursor: pointer;
        .item-title {
          color: #242933;
        }
        .item-title-active{
          // color: #2085e9;
          .title-text{
            font-weight: 600;
              color: #2085e9;
            }
        }
        &:hover {
          .item-title {
            color: #2085e9;
          }
        }
      }
    }
    .list-right {
      width: 50%;
      padding-left: 24px;
      height: 100%;
      overflow: auto;
      .list-item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        .item-title {
          height: fit-content;
          .title-text{
            color: #3D3D3D;
            font-weight: 600;
          }
        }
        .item-time {
          margin-top: 4px;
          color: #8a9099;
        }
        &:hover {
          .item-title {
            .title-text{
              color: #2085e9;
            }
          }
        }
      }
    }
    .list-none{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #525966;
    }
  }
}
</style>